import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _construct from "@babel/runtime/helpers/construct";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { InvalidScopeError, UnknownElementError } from './errors';
import { DEFAULT_INJECTION_CONTEXT } from './injection-context';
import { Module } from './module';
import { Reflector } from './reflection';
import { isForwardReference } from './types';
var GLOBAL_MODULE_NAME = '__GLOBAL_MODULE__';
export var DiContainer = /*#__PURE__*/function () {
  function DiContainer(_modules) {
    var _this = this;

    _classCallCheck(this, DiContainer);

    this._modules = _modules;
    this._isInitialized = false;

    this._modules.forEach(function (module) {
      return module.container = _this;
    });
  }

  _createClass(DiContainer, [{
    key: "globalModule",
    get: function get() {
      return this._modules.find(function (g) {
        return g.name === GLOBAL_MODULE_NAME;
      });
    }
  }, {
    key: "providers",
    get: function get() {
      return this._modules.reduce(function (memo, m) {
        return new Map([].concat(_toConsumableArray(memo), _toConsumableArray(m.providers)));
      }, new Map());
    }
  }, {
    key: "isInitialized",
    get: function get() {
      return this._isInitialized;
    }
  }, {
    key: "get",
    value: function get(token) {
      var provider = this.providers.get(token);

      if (provider == null) {
        throw new UnknownElementError(token);
      }

      if (provider.isTransient) {
        throw new InvalidScopeError(token);
      }

      return provider.getInstance(DEFAULT_INJECTION_CONTEXT);
    }
  }, {
    key: "resolve",
    value: function () {
      var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
        var context,
            inquirer,
            provider,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context = _args.length > 1 && _args[1] !== undefined ? _args[1] : DEFAULT_INJECTION_CONTEXT;
                inquirer = _args.length > 2 && _args[2] !== undefined ? _args[2] : {
                  id: Math.random()
                };
                provider = this.providers.get(token);

                if (!(provider == null)) {
                  _context.next = 5;
                  break;
                }

                throw new UnknownElementError(token);

              case 5:
                _context.next = 7;
                return provider.resolveInstance(context, inquirer);

              case 7:
                return _context.abrupt("return", _context.sent);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resolve(_x) {
        return _resolve.apply(this, arguments);
      }

      return resolve;
    }()
  }, {
    key: "resolveSync",
    value: function resolveSync(token) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INJECTION_CONTEXT;
      var inquirer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        id: Math.random()
      };
      var provider = this.providers.get(token);

      if (provider == null) {
        throw new UnknownElementError(token);
      }

      return provider.resolveInstanceSync(context, inquirer);
    }
  }, {
    key: "resolveDependencies",
    value: function () {
      var _resolveDependencies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(Class) {
        var _this2 = this;

        var deps, resolvedDependencies;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                deps = Reflector.getConstructorDependencies(Class);
                _context3.next = 3;
                return Promise.all(deps.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(token) {
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _this2.resolve(token);

                          case 2:
                            return _context2.abrupt("return", _context2.sent);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
                resolvedDependencies = _context3.sent;
                return _context3.abrupt("return", _construct(Class, _toConsumableArray(resolvedDependencies)));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function resolveDependencies(_x2) {
        return _resolveDependencies.apply(this, arguments);
      }

      return resolveDependencies;
    }()
  }, {
    key: "resolveDepsSync",
    value: function resolveDepsSync(Class) {
      var _this3 = this;

      var deps = Reflector.getConstructorDependencies(Class);
      var resolvedDependencies = deps.map(function (token) {
        return _this3.resolveSync(token);
      });
      return _construct(Class, _toConsumableArray(resolvedDependencies));
    }
  }, {
    key: "_createInstances",
    value: function () {
      var _createInstances2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _iterator, _step, module;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this._modules);
                _context4.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 9;
                  break;
                }

                module = _step.value;
                _context4.next = 7;
                return module.createInstances();

              case 7:
                _context4.next = 3;
                break;

              case 9:
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](1);

                _iterator.e(_context4.t0);

              case 14:
                _context4.prev = 14;

                _iterator.f();

                return _context4.finish(14);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 11, 14, 17]]);
      }));

      function _createInstances() {
        return _createInstances2.apply(this, arguments);
      }

      return _createInstances;
    }()
  }, {
    key: "_callOnInit",
    value: function () {
      var _callOnInit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iterator2, _step2, module;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper(this._modules);
                _context5.prev = 1;

                _iterator2.s();

              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context5.next = 9;
                  break;
                }

                module = _step2.value;
                _context5.next = 7;
                return module.callOnInit();

              case 7:
                _context5.next = 3;
                break;

              case 9:
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](1);

                _iterator2.e(_context5.t0);

              case 14:
                _context5.prev = 14;

                _iterator2.f();

                return _context5.finish(14);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 11, 14, 17]]);
      }));

      function _callOnInit() {
        return _callOnInit2.apply(this, arguments);
      }

      return _callOnInit;
    }()
  }, {
    key: "_callOnDidInit",
    value: function () {
      var _callOnDidInit2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _iterator3, _step3, module;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(this._modules);
                _context6.prev = 1;

                _iterator3.s();

              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context6.next = 9;
                  break;
                }

                module = _step3.value;
                _context6.next = 7;
                return module.callOnDidInit();

              case 7:
                _context6.next = 3;
                break;

              case 9:
                _context6.next = 14;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](1);

                _iterator3.e(_context6.t0);

              case 14:
                _context6.prev = 14;

                _iterator3.f();

                return _context6.finish(14);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 11, 14, 17]]);
      }));

      function _callOnDidInit() {
        return _callOnDidInit2.apply(this, arguments);
      }

      return _callOnDidInit;
    }()
  }], [{
    key: "from",
    value: function () {
      var _from = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(RootModule, kwargs) {
        var modulesMap, transform, globalModuleMeta, globalModule, modules, container;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                kwargs = _objectSpread({
                  globalProviders: []
                }, kwargs);
                modulesMap = new Map();

                transform = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(node) {
                    var _yield$Module$getMeta, name, metadata, module, imports, _iterator4, _step4, imported;

                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            if (!isForwardReference(node)) {
                              _context7.next = 4;
                              break;
                            }

                            _context7.next = 3;
                            return transform(node.forwardRef());

                          case 3:
                            return _context7.abrupt("return", _context7.sent);

                          case 4:
                            if (!modulesMap.has(node)) {
                              _context7.next = 6;
                              break;
                            }

                            return _context7.abrupt("return", modulesMap.get(node));

                          case 6:
                            _context7.next = 8;
                            return Module.getMetadata(node);

                          case 8:
                            _yield$Module$getMeta = _context7.sent;
                            name = _yield$Module$getMeta.name;
                            metadata = _objectWithoutProperties(_yield$Module$getMeta, ["name"]);
                            module = new Module(name, metadata, typeof node === 'function' ? node : undefined);
                            modulesMap.set(node, module);
                            imports = [];
                            _iterator4 = _createForOfIteratorHelper(metadata.imports);
                            _context7.prev = 15;

                            _iterator4.s();

                          case 17:
                            if ((_step4 = _iterator4.n()).done) {
                              _context7.next = 26;
                              break;
                            }

                            imported = _step4.value;
                            _context7.t0 = imports;
                            _context7.next = 22;
                            return transform(imported);

                          case 22:
                            _context7.t1 = _context7.sent;

                            _context7.t0.push.call(_context7.t0, _context7.t1);

                          case 24:
                            _context7.next = 17;
                            break;

                          case 26:
                            _context7.next = 31;
                            break;

                          case 28:
                            _context7.prev = 28;
                            _context7.t2 = _context7["catch"](15);

                            _iterator4.e(_context7.t2);

                          case 31:
                            _context7.prev = 31;

                            _iterator4.f();

                            return _context7.finish(31);

                          case 34:
                            module.imports = imports;
                            return _context7.abrupt("return", module);

                          case 36:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7, null, [[15, 28, 31, 34]]);
                  }));

                  return function transform(_x6) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                _context8.next = 5;
                return transform(RootModule);

              case 5:
                globalModuleMeta = {
                  exports: [],
                  imports: [],
                  providers: kwargs.globalProviders
                };
                globalModule = new Module(GLOBAL_MODULE_NAME, globalModuleMeta);
                modules = [globalModule].concat(_toConsumableArray(modulesMap.values()));
                container = new DiContainer(modules);
                _context8.next = 11;
                return container._createInstances();

              case 11:
                _context8.next = 13;
                return container._callOnInit();

              case 13:
                _context8.next = 15;
                return container._callOnDidInit();

              case 15:
                container._isInitialized = true;
                return _context8.abrupt("return", container);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function from(_x4, _x5) {
        return _from.apply(this, arguments);
      }

      return from;
    }()
  }]);

  return DiContainer;
}();